import { useTranslation } from 'react-i18next';

export default function FooterSection() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: t('nav.portfolio'), id: 'portfolio' },
    { label: t('nav.services'), id: 'services' },
    { label: t('nav.howWeWork'), id: 'howwework' },
    { label: t('footer.moneyButton'), id: 'moneybutton' },
    { label: t('nav.about'), id: 'about' },
    { label: t('nav.team'), id: 'team' },
    { label: t('nav.contact'), id: 'contact' },
  ];

  const serviceLinks = [
    t('footer.botDev'),
    t('footer.bizAuto'),
    t('footer.webDev'),
    t('footer.hosting'),
  ];

  return (
    <footer className="relative w-full bg-dark-800 border-t border-white/5">
      <div className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="flex-1">
              <img
                src="https://storage.readdy-site.link/project_files/cda64c73-0cd6-4b91-8a57-da1fc108f4d8/c8da654f-8114-430e-9c9c-3079f9d57510_svgmaker-editor.svg?v=bda0da09cbc0c79cb977d66f891a46d3"
                alt="Quaron Software"
                className="h-8 w-auto mb-4"
              />
              <p className="text-sm text-gray-400 max-w-xs leading-relaxed mb-6">
                {t('footer.description')}
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://github.com/QuaronSoftware"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-dark-500 flex items-center justify-center text-gray-400 hover:text-white hover:bg-neon-blue/10 transition-all duration-300"
                >
                  <i className="ri-github-fill text-lg" />
                </a>
                <a
                  href="https://t.me/notGucuL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-dark-500 flex items-center justify-center text-gray-400 hover:text-white hover:bg-neon-blue/10 transition-all duration-300"
                >
                  <i className="ri-telegram-fill text-lg" />
                </a>
              </div>
            </div>

            <div className="flex-1">
              <h4 className="text-sm font-semibold text-white mb-4">{t('footer.navigation')}</h4>
              <div className="grid grid-cols-2 gap-2">
                {navLinks.map((link) => (
                  <button
                    key={link.id}
                    onClick={() => scrollTo(link.id)}
                    className="text-left text-sm text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-1">
              <h4 className="text-sm font-semibold text-white mb-4">{t('nav.services')}</h4>
              <ul className="space-y-2">
                {serviceLinks.map((item) => (
                  <li key={item}>
                    <button
                      onClick={() => scrollTo('services')}
                      className="text-sm text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer"
                    >
                      {item}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

          </div>

          <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-gray-600">
              {new Date().getFullYear()} {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-4 text-xs text-gray-600">
              <span className="cursor-pointer hover:text-gray-400 transition-colors">{t('footer.privacy')}</span>
              <span className="cursor-pointer hover:text-gray-400 transition-colors">{t('footer.terms')}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
